import { useState } from 'react';

import { Modal } from '@thefarmersfront/kitchen';

import { ModalContentsContainer, ModalLabelValueRow, ModalSection, Table } from '~/components/common';

import { useModal } from '~/hooks/common';
import {
  getClaimExchangeDetailDeliveryColumnDefs,
  getClaimExchangeDetailInspectionColumnDefs,
  getClaimExchangeDetailTrackingColumnDefs,
} from '~/utils/claim';

import { ClaimDetailInspectionImageModal } from '../../ClaimDetailInspectionImageModal';

import type { TypeExchangeDetailData } from '~/types/claim.types';

import styles from './ClaimExchangeDetailModal.module.scss';

const ClaimExchangeDetailModal = ({
  data,
  isOpen,
  onConfirm,
  onClickOutboundOrderCode,
}: {
  data: TypeExchangeDetailData | null;
  isOpen: boolean;
  onConfirm: () => void;
  onClickOutboundOrderCode: (outboundOrderCode: string) => void;
}) => {
  const [selectedImageList, setSelectedImageList] = useState<string[] | null>(null);

  const { columnDefs: trackingColumnDefs } = getClaimExchangeDetailTrackingColumnDefs();
  const { columnDefs: inspectionColumnDefs, gridOptions: inspectionGridOptions } =
    getClaimExchangeDetailInspectionColumnDefs({
      onClickViewInspectionImage: (imageList) => {
        setSelectedImageList(imageList);
        inspectionImageModal.handleOpenModal();
      },
    });
  const { columnDefs: deliveryInfoColumnDefs } = getClaimExchangeDetailDeliveryColumnDefs({
    onClickOutboundOrderCode,
  });

  const inspectionImageModal = useModal();

  if (!data) return null;

  return (
    <>
      <Modal title="교환 신청 상세" size="xlarge" open={isOpen} onConfirm={onConfirm}>
        <ModalContentsContainer>
          <ModalSection title="회수 신청 정보">
            <div className={styles['info-container']}>
              <ModalLabelValueRow label="교환요청번호" value={data.exchangeReceiptId} />
              <ModalLabelValueRow label="원주문 수령자명" value={data.returnOrder.member.name} />
              <ModalLabelValueRow label="기본주소" value={data.returnOrder.returnPlace.primaryAddress} />
              <ModalLabelValueRow label="상세주소" value={data.returnOrder.returnPlace.secondaryAddress ?? '-'} />
            </div>
          </ModalSection>
          <ModalSection title="회수 송장 정보">
            <Table
              className={styles['table']}
              data={data.returnOrder.returnOrderTrackings ?? []}
              options={{ columnDefs: trackingColumnDefs }}
              rowStatusType="NO_DATA"
            />
          </ModalSection>
          <ModalSection title="검수 처리 상세">
            <Table
              className={styles['table']}
              data={data.returnOrder.returnGoodsInspections}
              options={{ columnDefs: inspectionColumnDefs, ...inspectionGridOptions }}
              rowStatusType="NO_DATA"
            />
          </ModalSection>
          <ModalSection title="교환 배송 정보">
            <Table
              className={styles['table']}
              data={data.exchangeOrder.exchangeOrderItems ?? []}
              options={{ columnDefs: deliveryInfoColumnDefs }}
              rowStatusType="NO_DATA"
            />
          </ModalSection>
        </ModalContentsContainer>
      </Modal>
      {inspectionImageModal.isOpen && selectedImageList && (
        <ClaimDetailInspectionImageModal
          mode="exchange"
          isOpen={inspectionImageModal.isOpen}
          imageList={selectedImageList}
          onClose={inspectionImageModal.handleCloseModal}
        />
      )}
    </>
  );
};

export default ClaimExchangeDetailModal;
